import classNames from "classnames";
import { FunctionComponent } from "react";

interface InputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {}

const Input: FunctionComponent<InputProps> = ({ className, ...inputProps }) => {
  return (
    <input
      className={classNames(
        className,
        "h-[32px] px-4 rounded-full border border-black/20 bg-white outline-none focus:border-main-to"
      )}
      {...inputProps}
    ></input>
  );
};

export default Input;
